import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: 4px 0;
  position: relative;
`;

export const Stripe = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.danger_500};
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
`;
